import { productFamilyIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import { null as zNull } from "zod";

/** Fans out to every variant in the family; `publish: null` clears the override. */
export const setProductFamilyPublishOverride = {
  name: "setProductFamilyPublishOverride" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    destinationCountryCode: z.string(),
    publish: z.boolean().nullable(),
  }),
  output: zNull(),
};
